import { useDebounceFn } from '@vueuse/core';
import { useBFF } from '~/composables/useBFF/useBFF';

const result = ref();
const useAddress = () => {
  const { $geoapify } = useBFF();
  const error = ref({ load: false });

  const debouncedAutocomplete = useDebounceFn(async (text: string) => {
    await autocomplete(text);
  }, 1000);

  const autocomplete = async (text: string) => {
    try {
      const { data } = await $geoapify.getAutocomplete(text);
      result.value = data;
    }
    catch {
      error.value.load = true;
    }
  };

  const validateAddress = async (address: any) => {
    try {
      const { data } = await $geoapify.checkAddressConfidence({ address });
      const normalize = (str: string) => (str || '').toString().trim().toLowerCase();

      const isSame
        = normalize(data.features[0].properties.street) === normalize(address.streetName)
          && normalize(data.features[0].properties.housenumber) === normalize(address.streetNumber)
          && normalize(data.features[0].properties.postcode) === normalize(address.postalCode)
          && normalize(data.features[0].properties.city) === normalize(address.city)
          && normalize(data.features[0].properties.country_code) === normalize(address.country);

      const filteredRecommendations = (data.features ?? []).filter(
        (f: any) => !!f.properties.street,
      );

      return {
        valid: isSame,
        recommendations: isSame ? [] : filteredRecommendations,
      };
    }
    catch (e) {
      error.value.load = true;
      console.log('error', e);
      return { valid: false, recommendations: [] };
    }
  };

  const resetResults = () => {
    result.value = null;
  };

  return {
    result: computed(() => result.value),
    error: computed(() => error.value),
    autocomplete,
    resetResults,
    validateAddress,
    debouncedAutocomplete,
  };
};

export default useAddress;
